import { useCallback, useMemo } from 'react'
import {
  BulkSheetColumnAndFilterState,
  BulkSheetViewColumnAndFilterState,
} from '../../../view/model/bulkSheetColumnAndFilterState'
import { PermanentUiState } from '../../model/uiState'
import { usePermanentUiStateStorageService } from './permanentUiStateStorageService'
import { adaptPermanentUiStateBefore20220208 } from '../../compatible-adaptors/permanentUiStateCompatibleAdaptor'

type ColumnAndFilterStateStorageService = {
  stored: PermanentUiState<BulkSheetColumnAndFilterState>[]
  fetch: () => Promise<void>
  getByCode: (
    code: string
  ) => Promise<PermanentUiState<BulkSheetViewColumnAndFilterState> | undefined>
  // TODO: add `save` and `delete` functions/
}

export const useColumnAndFilterStateStorageService = (
  functionUuid: string,
  projectUuid: string,
  ticketType?: string
): ColumnAndFilterStateStorageService => {
  const permanentUiStateStorageService = usePermanentUiStateStorageService(
    functionUuid,
    'BULK_SHEET_UI_STATE_COLUMN_AND_FILTER',
    projectUuid,
    ticketType
  )

  const stored = useMemo(
    () => permanentUiStateStorageService.stored,
    [permanentUiStateStorageService.stored]
  )

  const fetch = useCallback(async () => {
    return permanentUiStateStorageService.fetch()
  }, [permanentUiStateStorageService.fetch])

  const getByCode = useCallback(
    async (code: string) => {
      const response = await permanentUiStateStorageService.getByCode(code)
      if (!response) return undefined
      return adaptPermanentUiStateBefore20220208(response)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [permanentUiStateStorageService.getByCode]
  )

  return {
    stored,
    fetch,
    getByCode,
  }
}
